import { FormGroup } from '@angular/forms';
import { Component, OnInit, ViewEncapsulation, Input, OnDestroy } from '@angular/core';
import { UserAdminService } from '../user-admin.service';
import { UserList } from '../models/user-list';
import { EventTypes } from '../../../shared/EventTypes';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { TweenMax, Quint } from 'gsap';
import { AutenticationService } from '../../../autentication/autentication.service';
import { EditUserData } from '../models/edit-user-data';
import { UserAdminEventType } from '../user-admin.event.type';
import { Auth } from '../../../autentication/Auth';
import { ThemeService } from '../../../shared/theme-service/theme.service';

@Component({
	selector: 'app-user-table',
	templateUrl: './user-table.component.html',
	styleUrls: ['./user-table.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class UserTableComponent implements OnInit, OnDestroy {

	@Input() submited: boolean;

	userList: Array<UserList> = [];
	isLoading: boolean;
	isDeleting = false;
	notifyOpen = false;
	formSignature: FormGroup;
	deleteConfirm = true;
	activeIndex: number;
	isAttendant = false;

	constructor(private userAdminService: UserAdminService, private autenticationService: AutenticationService, private themeService: ThemeService) { }

	ngOnInit() {
		this.isAttendant = this.themeService.isAttendant();

		this.listUsers();

		AppEventDispatcher.listen(UserAdminEventType.USER_TABLE_UPDATE, () => {

			this.listUsers();

		});

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(UserAdminEventType.USER_TABLE_UPDATE);
	}

	listUsers() {
		this.isLoading = true;

		this.userAdminService.getUsers().subscribe( data => {
			this.userList = data;
			this.isLoading = false;
		}, error => {
			this.isLoading = false;
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	onSetSignatureForm(form: FormGroup) {
		this.formSignature = form;
	}

	notifyDeleteUser(e, index) {
		const itemSelected = e.currentTarget.parentElement.parentElement.nextElementSibling;

		if (!this.notifyOpen) {
			this.notifyOpen = true;

			this.activeIndex = index;

			TweenMax.set(itemSelected, { height: 'auto', ease: Quint.easeInOut });
			TweenMax.from(itemSelected, .7 , { height: 0, ease: Quint.easeInOut });
		}
	}

	closeDeleteUser() {
		this.notifyOpen = false;

		this.activeIndex = null;

		TweenMax.to('[data-component="user-table"] .notify', .5 , {
			height: 0,
			ease: Quint.easeInOut,
			onComplete: () => {
				this.deleteConfirm = true;
				this.submited = false;
			}
		});
	}

	digitalSignature() {

		this.deleteConfirm = false;

		TweenMax.from('[data-component="user-table"] .notify', .7 , {
			height: 110,
			ease: Quint.easeOut
		});

	}

	addAuthToken() {
		Auth.passToken = this.formSignature.value.token ? this.formSignature.value.token : '';
		Auth.assinaturaEletronica = this.formSignature.value.eletronicSignature ? this.formSignature.value.eletronicSignature : '';
	}

	deleteUser(cpf: number) {
		this.submited = true;

		if (this.formSignature.valid && !this.isDeleting) {

			this.isDeleting = true;
			this.submited = false;
			this.addAuthToken();

			this.autenticationService.sendDigitalSignature(this.formSignature.value.eletronicSignature).subscribe(d => {
				this.userAdminService.deleteUser(cpf).subscribe( data => {

					this.isDeleting = false;
					this.closeDeleteUser();
					this.listUsers();
					AppEventDispatcher.dispatch(UserAdminEventType.USER_ADMIN_DELETE, { msg: data.Mensagem });

				}, error => {
					this.isDeleting = false;

					this.closeDeleteUser();

					this.listUsers();

					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.Mensagem });
				});
			}, error => {
				this.isDeleting = false;
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			});

		}
	}

	editUser(cpf) {
		AppEventDispatcher.dispatch(UserAdminEventType.USER_ADMIN_EDIT, {edit: true, cpf: cpf});
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD, {element: '[data-component="user-admin"] .content', show: active, delay: delay});
	}

	public getMessageConfirmedDelete(message: boolean, cpf: number) {
		if (message) {
			this.deleteUser(cpf);
		}
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/user-admin/user-table/user-table.component.ts